import render from './render'

export default {
  name: 'Port',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
